import { plainToClass, classToPlain } from 'class-transformer'
import http from '../http';
import { Page } from '@/models/page.model';
import { AnagraficaRequest, Anagrafica } from '@/models/anagrafica.model';

export class AnagraficaService {

  constructor() {}
  
  search(request: AnagraficaRequest, page: Page): Promise<any> {
    return new Promise((resolve, reject) => {
      http.post(`anagrafica/search/range/${page.start}/${page.stop}`, classToPlain(request)).then((response: any) =>
        resolve(plainToClass(Anagrafica, response.data))).catch((error: any) => reject(error))
    })
  }

  searchCount(request: AnagraficaRequest): Promise<any> {
    return new Promise((resolve, reject) => {
      http.post(`anagrafica/search/count`, classToPlain(request)).then((response: any) =>
        resolve(plainToClass(Anagrafica, response.data))).catch((error: any) => reject(error))
    })
  }

  getAnagrafica(id: number): Promise<any> {
    return new Promise((resolve, reject) => {
      http.get(`anagrafica/${id}`).then((response: any) =>
        resolve(plainToClass(Anagrafica, response.data))).catch((error: any) => reject(error))
    })
  }

}
